module.exports = __webpack_public_path__ + "img/salt.1798b8ca.svg";